// hooks/useUSDTBalance.js
import { useReadContract } from 'wagmi';
import { ethers } from 'ethers';
import { useAppKitAccount } from '@reown/appkit/react';
import { erc20Address, provider } from '../../../.config';
import erc20abi from '../../../abi/ERC20_ABI.json';

export const useUSDTBalance = () => {
  const { address } = useAppKitAccount();

  // balanceOf USDT
  const usdtBalanceHook = useReadContract({
    address: erc20Address,
    abi: erc20abi.abi,
    functionName: 'balanceOf',
    args: [],
    enabled: false,
  });

  const getUSDTBalance = async (accountAddr) => {
    try {
      if (!accountAddr) return "0.00";
      
      const contract = new ethers.Contract(erc20Address, erc20abi.abi, provider);
      const usdtBalance = await contract.balanceOf(accountAddr);
      return parseFloat(ethers.utils.formatUnits(usdtBalance, 6)).toFixed(2);
    } catch (error) {
      console.error("Error fetching USDT balance:", error);
      return "0.00";
    }
  };

  return {
    getUSDTBalance
  };
};

export default useUSDTBalance;
